//话术分类表头
export const columnSpeach = [
  {
    title: '话术ID',
    dataIndex: 'id',
    key: 'id',
    width: 80
  },
  {
    title: '话术分类',
    dataIndex: 'phraseName',
    key: 'phraseName',
    width: 100
  },
  {
    title: '话术内容',
    dataIndex: 'chatContent',
    key: 'chatContent',
    width: 200,
    ellipsis: true
  },
  {
    title: '选用次数',
    dataIndex: 'phraseNum',
    key: 'phraseNum',
    width: 100
  },
  {
    title: '编辑人',
    dataIndex: 'editName',
    key: 'editName',
    width: 100
  },
  {
    title: '编辑时间',
    dataIndex: 'editTime',
    key: 'editTime',
    width: 150
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    width: 100,
    slots: { customRender: 'action' }
  }
]
